/** Tham chiếu `--ui-*-*` đồng bộ bởi `syncUiCssVars` (khớp ytl-logistics-frontend). */
const toKebab = (segment: string): string =>
  segment.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase()

export const cv = (...pathSegments: string[]): string =>
  `var(--ui-${pathSegments.map(toKebab).join('-')})`
